export const isFetching = state => state.dashboards.widgets.fetching;
export const widgets = state => state.dashboards.widgets.widgets || {};
export const error = state => state.dashboards.widgets.error;
